import { Box, Modal, Text } from '@mantine/core';
import DeleteIcon from '../../../assets/icons/deleteSmall.svg';
import {data} from './properties';
import {useStyles} from './style';
import cancelIcon from '../../../assets/icons/cross.svg';

function LanLordListPopup({
  opened,
  close,
  landlordLists,
  handleDeleteLandlord,
}) {
  const { classes, theme } = useStyles(useStyles);

  return (
    <Modal
      withCloseButton={false}
      opened={opened}
      onClose={close}
      size='lg'
      title={data.titles.modalTitle}
      centered={true}
      styles={{
        content:classes.content,
        title: classes.modalTitle,
      }}
    >
      <img
        onClick={close}
        className={classes.cancelIconModal}
        src={cancelIcon}
        height={14}
        width={14}
        alt='cancel'
      />
      {landlordLists?.map((item, index) => (
        <Box key={index} className={classes.popupList}>
          <Text size='xl' className={classes.emailText}>
            {item}
          </Text>
          <img
            width='14px'
            height='18px'
            src={DeleteIcon}
            alt='delete'
            onClick={() => handleDeleteLandlord(item)}
            style={{ cursor: 'pointer' }}
          />
          </Box>
      ))}
    </Modal>
  );
}

export default LanLordListPopup;
